import { DefaultFetchService } from "app/services/fetchService";
import type { ICountryObject } from "app/services/CountryService";
import type { ICategory } from "app/common/services/categoryService.types";
import type {
    IFilters,
    IRawData } from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";
import {
    PRE_DEFINED_PERIOD_CHANGE,
} from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";
import { getCommonQueryParams } from "app/pages/industry-analysis/market-builder/tabs/common/utils";
import { INITIAL_TRAFFIC } from "./constants";
import type { INumberRange } from "app/UtilitiesAndConstants/types/range";

const ENDPOINT = "api/MarketBuilder/ByIndustry/Table";

const getQueryParams = (countryObject: ICountryObject, industry: ICategory, filters: IFilters) => {
    const { websiteType, orderBy } = filters;
    const { field: sort, sortDirection } = orderBy;
    const keys = industry.forApi;
    return {
        ...getCommonQueryParams(countryObject, websiteType),
        keys,
        orderBy: `${sort} ${sortDirection}`,
    };
};

const resolveRangeFilterApiValue = (
    rangeFilterValue: INumberRange,
    initialRangeFilterValue: INumberRange,
): INumberRange => {
    const apiValue = { from: rangeFilterValue.from, to: rangeFilterValue.to };
    if (rangeFilterValue.from === initialRangeFilterValue.from) {
        delete apiValue.from;
    }
    if (rangeFilterValue.to === initialRangeFilterValue.to) {
        delete apiValue.to;
    }
    const hasKeys = Object.keys(apiValue).length > 0;
    return hasKeys ? apiValue : null;
};

const getPayload = (filters: IFilters) => {
    const { traffic } = filters;
    const { monthlyVisits, uniqueUsers, isUniqueToggle } = traffic;
    const periodChange = isUniqueToggle ? PRE_DEFINED_PERIOD_CHANGE : null;
    const { monthlyVisits: initialMonthlyVisits, uniqueUsers: initialUniqueUsers } = INITIAL_TRAFFIC;

    const requestBody = {
        monthlyVisits: resolveRangeFilterApiValue(monthlyVisits, initialMonthlyVisits),
        uniqueVisitors: resolveRangeFilterApiValue(uniqueUsers, initialUniqueUsers),
        PeriodChange: periodChange,
    };
    return requestBody;
};

export const fetchData = (country: ICountryObject, industry: ICategory, filters: IFilters): Promise<IRawData> => {
    const fetchService = DefaultFetchService.getInstance();
    const queryParams = getQueryParams(country, industry, filters);
    const url = `${ENDPOINT}?${fetchService.requestParams(queryParams)}`;
    const payload = getPayload(filters);
    const rawDataPromise = fetchService.post<IRawData>(url, payload);
    return rawDataPromise;
};
